import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto relative z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="/waybook-logo.svg" 
              alt="Waybook" 
              className="h-8 mb-4"
            />
            <p className="text-gray-600 text-sm">
              Your travel companion for unforgettable adventures.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-gray-600 hover:text-black">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-gray-600 hover:text-black">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/age-suitability" className="text-gray-600 hover:text-black">
                  Age Suitability
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Accessibility</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/app-accessibility" className="text-gray-600 hover:text-black">
                  App Accessibility
                </Link>
              </li>
              <li>
                <Link to="/dsa-labels" className="text-gray-600 hover:text-black">
                  DSA Labels & Markings
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/recommended" className="text-gray-600 hover:text-black">
                  Recommended
                </Link>
              </li>
              <li>
                <Link to="/roadmap" className="text-gray-600 hover:text-black">
                  Roadmap
                </Link>
              </li>
              <li>
                <Link to="/press-release" className="text-gray-600 hover:text-black">
                  Press Release
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-black">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Waybook. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
